import React from 'react';

import BtcVerifier from './views/BtcVerifier';

import GlobalStyles from './styles/GlobalStyles';

export default function App() {
  return (
    <>
      <BtcVerifier />
      <GlobalStyles />
    </>
  );
}
